module.exports = __webpack_public_path__ + "static/hero6-8ab16e22ba177c6d33025c35c9f55520.webp";